export const MuiToolbar = {
    styleOverrides: {
        semiDense: {
            minHeight: "56px"
        }
    }
};
//# sourceMappingURL=Toolbar.js.map